// extracted by mini-css-extract-plugin
export default {"route":"classes_route__TNT56","content":"classes_content__84BAz","link":"classes_link__XaHsO","active-route":"classes_active-route__S5Hod"};